import React from 'react';
import TasksPane from './components/Tasks/TasksPane';
import ContractItemsPane from './components/ContractItems/ContractItemsPane';
import EventsPane from './components/EventsPane/EventsPane';
import ClientAndLocationPane from './components/ClientsAndLocations/ClientAndLocationPane';
import { useClientAndLocationPaneVisible } from '@/app/state/ui/customerService/clientsAndLocations/index.hooks';
import {
    useBottomGrid,
    useBottomGridPaneVisible,
} from '@/app/state/ui/customerService/bottomGrid/index.hooks';

const ClientServicePane = () => {
    const bottomGrid = useBottomGrid();

    const clientAndLocationPaneVisible = useClientAndLocationPaneVisible();
    const bottomGridVisible = useBottomGridPaneVisible();

    if (bottomGridVisible) {
        switch (bottomGrid) {
            case 'Tasks':
                return <TasksPane />;
            case 'ContractItems':
                return <ContractItemsPane />;
            case 'Events':
            case 'EventsByRfid':
                return <EventsPane />;
            default:
                return null;
        }
    }

    return clientAndLocationPaneVisible ? <ClientAndLocationPane /> : null;
};

export default ClientServicePane;
